/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Zadejte svůj e-mail níže. Zašleme vám odkaz na obnovení hesla.`
};

const da_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Indtast din email nedenfor. Vi sender dig et link til at nulstille din adgangskode.`
};

const de_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Geben Sie unten Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.`
};

const en_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Please enter your email address below. You will receive a link to reset your password.`
};

const es_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Introduce tu correo electrónico abajo. Te enviaremos un enlace para restablecer tu contraseña.`
};

const fr_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Saisissez votre email ci-dessous. Nous vous enverrons un lien pour réinitialiser votre mot de passe.`
};

const hu_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Add meg az e-mail címed az alábbiakban. Küldünk egy linket a jelszó visszaállításához.`
};

const it_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Inserisci la tua email qui sotto. Ti invieremo un link per reimpostare la password.`
};

const nl_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Vul hieronder je e-mailadres in. We sturen je een link om je wachtwoord te resetten.`
};

const pl_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Podaj swój e-mail poniżej. Wyślemy Ci link do zresetowania hasła.`
};

const pt_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Digite seu e-mail abaixo. Enviaremos um link para redefinir sua senha.`
};

const sv_account_forgot_password_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Ange din e-post nedan. Vi skickar en länk för att återställa ditt lösenord.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_forgot_password_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_forgot_password_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_forgot_password_subtitle", locale)
	if (locale === "cs") return cs_account_forgot_password_subtitle(inputs)
	if (locale === "da") return da_account_forgot_password_subtitle(inputs)
	if (locale === "de") return de_account_forgot_password_subtitle(inputs)
	if (locale === "en") return en_account_forgot_password_subtitle(inputs)
	if (locale === "es") return es_account_forgot_password_subtitle(inputs)
	if (locale === "fr") return fr_account_forgot_password_subtitle(inputs)
	if (locale === "hu") return hu_account_forgot_password_subtitle(inputs)
	if (locale === "it") return it_account_forgot_password_subtitle(inputs)
	if (locale === "nl") return nl_account_forgot_password_subtitle(inputs)
	if (locale === "pl") return pl_account_forgot_password_subtitle(inputs)
	if (locale === "pt") return pt_account_forgot_password_subtitle(inputs)
	return sv_account_forgot_password_subtitle(inputs)
};
export { account_forgot_password_subtitle as "account.forgot_password_subtitle" }